import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StoreContext from '../../context/store/storeContext';

const SmartRedirect = ({ target }) => {
    const storeContext = useContext(StoreContext);
    const { stores, getStores, loading } = storeContext;
    const navigate = useNavigate();

    useEffect(() => {
        getStores();
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (loading) return;
        
        if (stores && stores.length > 0) {
            // İlk mağazaya yönlendir
            if (target === 'menus') {
                // Menü için: /store/:id (Burada menü butonu var) veya direkt menüye gitmek istiyorsa 
                // aslında /menu/:id var ama menu_id bilmiyoruz.
                // Store detay sayfasında "Menüler" sekmesi veya butonu var.
                navigate(`/store/${stores[0].store_id}`); 
            } else if (target === 'orders') {
                navigate(`/store/${stores[0].store_id}/orders`);
            }
        } else {
            // Mağaza yoksa dashboard'a git
            navigate('/dashboard');
        }
    }, [stores, loading, navigate, target]);

    return (
        <div className="flex h-screen w-full items-center justify-center bg-background-dark text-white">
            <div className="flex flex-col items-center gap-4">
                <div className="w-12 h-12 border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
                <p className="text-gray-400 font-medium">Yönlendiriliyor...</p>
            </div>
        </div>
    );
};

export default SmartRedirect;
